<template>
  <ul class="divide-y divide-gray-200">
    <li v-for="(dataLog, index) in dataLogs" :key="index" class="py-4 flex space-x-3">
      <div class="flex justify-between w-full">
        <span class="text-sm leading-5 font-medium text-gray-900 mb-2">
          Logged for
          <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-yellow-100 text-yellow-800">
            {{ dataLog.duration }}
          </span>
          <p class="text-sm font-medium text-gray-900">Started by {{ dataLog.creating_user.display_name }}</p>
          <p class="truncate text-sm text-gray-500">Started on {{ dataLog.created_at_readable }}</p>
        </span>
        <span>
          <a @click="this.$emit('show:dataLogs', dataLog)"
             class="plain-link hidden rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:block">
            View data
          </a>
        </span>
      </div>
    </li>

  </ul>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import axios from "axios";
import Loading from "@/components/elements/loading";

export default {
  name: "MeterViewDataLogs",
  components: {Loading},
  mixins: [ SonicuCoreMixin ],
  emits: ['show:dataLogs'],
  props: {
    dataLogs: {
      type: Array,
      default: () => []
    },
  },
  data(){
    return {
    }
  },
  mounted() {
  },
  methods: {
  },
  computed: {
  }
}
</script>

<style scoped>

</style>